import { faker } from "@faker-js/faker";
import { fakerDateString } from "lib/faker";
import {
  MaintenanceTaskStatus,
  type MaintenanceTask,
} from "types/maintenance-task";
import { TaskPriority } from "types/task";

// Mock a maintenance task user the faker library for everything
export const mockMaintenanceTask = ({
  propertyId,
}: {
  propertyId?: string;
} = {}): MaintenanceTask => {
  return {
    id: faker.string.uuid(),
    property_id: propertyId ?? faker.string.uuid(),
    summary: faker.lorem.sentence(),
    description: faker.lorem.paragraph(),
    status_id: faker.helpers.arrayElement([
      MaintenanceTaskStatus.JobLogged,
      MaintenanceTaskStatus.WorkFinished,
      MaintenanceTaskStatus.WorkOrderAssigned,
    ]),
    priority_id: faker.helpers.arrayElement([
      TaskPriority.Preventative,
      TaskPriority.Normal,
      TaskPriority.Urgent,
      TaskPriority.Emergency,
    ]),
    updated_at: fakerDateString(),
    images: Array.from({ length: 3 }).map(() => ({
      sources: [
        {
          type: "url",
          url: faker.image.urlPicsumPhotos({ width: 1440, height: 1080 }),
          width: 1440,
          height: 1080,
        },
      ],
    })),
    work_assigned_to: faker.person.firstName() + " " + faker.person.lastName(),
    closed_at: faker.datatype.boolean()
      ? faker.date.anytime().toDateString()
      : null,
  };
};
